import React, { useState } from 'react';
import type { FC } from 'react';
import { useBiLogger } from '@wix/cli-telemetry-react';
import type { DeveloperApp } from '@wix/dev-center-client';
import type { RepoType } from '@wix/package-manager';
import { TemplateSource } from '../../parse-command-options.js';
import type { AppData, GenerationData } from '../../types.js';
import { ChoosePackageName } from '../ChoosePackageName.js';
import { ExtendExistingApp } from '../ExtendExistingApp.js';
import { McpConfigResult } from '../mcp/getMcpResult.js';

interface ExistingAppFlowProps {
  targetParentFolder: string;
  repoType: RepoType;
  developerApps: DeveloperApp[];
  onSubmit: (data: GenerationData) => void;
}

export const ExistingAppFlow: FC<ExistingAppFlowProps> = ({
  onSubmit,
  developerApps,
  targetParentFolder,
  repoType,
}) => {
  const biLogger = useBiLogger();
  const [appData, setAppData] = useState<AppData>();

  return (
    <>
      <ExtendExistingApp
        developerApps={developerApps}
        onSelected={(appData) => {
          biLogger.updateDefaults({
            _appId: appData.appId,
          });
          setAppData(appData);
        }}
      />

      {appData && (
        <ChoosePackageName
          appName={appData.appName}
          targetParentFolder={targetParentFolder}
          repoType={repoType}
          onSelected={(packageName) => {
            onSubmit({
              appData,
              packageName,
              template: TemplateSource.Default(),
              mcpConfigResult: McpConfigResult.Canceled(),
            });
          }}
        />
      )}
    </>
  );
};
